//NPM
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { isNil, omitBy } from 'lodash'
import moment from 'moment';

// UTILITY
import errorHandler from "Utils/error-handler";

// HELPERS
import { toaster } from "Helpers/toaster";

//STYLE
import "../parcel-tracking-modals.scss";
import { CalendarOutlined } from "@ant-design/icons";

//SERVICES
import { listLines, fetchLine } from "Services/delivery-settings.services";

// HOOKS
import useSession from "Hooks/session.hook";

//ANT COMPONENTS
import { AlertBox, Button, SelectInput, DatePicker } from "@life-line-lab/components-react";
import ModuleTitleBar from "Components/shared/module-title-bar/module-title-bar";

interface PlanNewTrainProps {
  trainLineOptions?: any;
  trainStationOptions?: any;
  onSubmit?: any;
  onCancel: any;
  getStations?: any;
}

const PlanNewTrainModal: React.FC<PlanNewTrainProps> = ({
  onSubmit,
  trainLineOptions,
  onCancel
}) => {
  const { t } = useTranslation();
  const initialInput = {
    trainLine: '',
    startStation: "",
    lastStation: "",
    plannedDeparture: "",
  };
  const initialError = {};
  const [input, setInput] = useState(initialInput);
  const [error, setError] = useState<any>(initialError);
  const [trainStationOptions, setTrainStationOptions] = useState<any>([])


  //TODO: I called the API here instead of page because it doesn't update the dropdown, and I'm kinda in a rush to complete it -Jazz
  const listTrainStationOptions = async (trainLineID) => {
    const responseData = await fetchLine(trainLineID)
    if (responseData) {
      setTrainStationOptions(responseData.stations)
    }
  }

  const handleSelectChange = (value: string | string[], name: string) => {
    setError({ ...error, [name]: null });
    setInput({ ...input, [name]: value });
  };

  const handleTrainSelectChange = (value: string | string[], name: string) => {
    listTrainStationOptions(value)
    setError({ ...error, [name]: null });
    setInput({ ...input, [name]: value, startStation: '', lastStation: '' });
  }

  const handleTimeChange = (time: any) => {
    setInput({ ...input, plannedDeparture: time.toISOString() });
  }

  const onOk = (time: any) => {
    setInput({ ...input, plannedDeparture: time.toISOString() });
  };

  const handleSubmit = () => {
    const valInput = {
      ...input,
      status: 'PLANNED'
    }
    onSubmit(valInput)
  }

  return (
    <div className="parcel-tracking-modal">
      <ModuleTitleBar titleText={t("title.planNewTrain").toUpperCase()} />
      <div className="mt-20">
        <SelectInput
          showSearch
          isRequired={true}
          label={t("label.trainLine")}
          options={trainLineOptions.map(line => {
            return {
              label: line.name,
              value: line._id
            }
          })
            || []}
          filterOption={(inputValue, option) =>
            option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
          }
          value={input.trainLine}
          name="trainLine"
          placeholder={t("txt.selectHere")}
          onChange={(value: string | string[]) => handleTrainSelectChange(value, "trainLine")}
        />
      </div>
      <div className="mt-10">
        {<SelectInput
          showSearch
          filterOption={(inputValue, option) =>
            option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
          }
          isRequired={true}
          label={t("label.startStation")}
          options={trainStationOptions.map(station => {
            return {
              label: station.stationName,
              value: station.stationCode
            }
          })}
          value={input.startStation}
          name="startStation"
          placeholder={t("txt.selectHere")}
          onChange={(value: string | string[]) => handleSelectChange(value, "startStation")}
        />}
      </div>
      <div className="mt-10">
        <SelectInput
          showSearch
          isRequired={true}
          label={t("label.lastStation")}
          options={trainStationOptions.map(station => {
            return {
              label: station.stationName,
              value: station.stationCode
            }
          }) || []}
          filterOption={(inputValue, option) =>
            option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
          }
          value={input.lastStation}
          name="lastStation"
          placeholder={t("txt.selectHere")}
          onChange={(value: string | string[]) => handleSelectChange(value, "lastStation")}
        />
      </div>
      <div className="mt-10">
        <DatePicker
          isRequired={true}
          showTime={{ format: 'HH:mm' }}
          format="YYYY-MM-DD HH:mm"
          placeholder={'Departure Time'}
          label={'Planned Departure Time'}
          value={input.plannedDeparture ? moment(input.plannedDeparture) : null}
          onOk={onOk}
          onChange={handleTimeChange}
        />
      </div>
      <div className="mt-30 right">
        <Button
          type={"primary"}
          label={t("action.confirm")}
          onClick={() => {
            handleSubmit();
          }}
        />
        <Button
          className="cancel-btn"
          type={"default"}
          label={t("action.cancel")}
          onClick={() => {
            onCancel();
          }}
        />
      </div>
    </div>
  );
};

export default PlanNewTrainModal;
